import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["entries", "pagination"]
  }

  scroll() {
    if (this.isBottomVisible()) {
      this.loadMore()
    }
  }

  loadMore() {
    let link = this.paginationTarget.querySelector("a[rel=next]")

    if (link) {
      link.click()
    }
  }

  isBottomVisible() {
    const rect = this.entriesTarget.getBoundingClientRect()
    const containerRect = this.element.getBoundingClientRect()
    return rect.bottom <= containerRect.bottom
  }
}
